export function normalizeMemberChatEnabled(value) {
	if (value === true || value === 1) {
		return true;
	}

	if (typeof value !== "string") {
		return false;
	}

	const normalizedValue = value.trim().toLowerCase();
	return normalizedValue === "1" || normalizedValue === "true";
}

export function isChatEnabledForMember(member, fallback = false) {
	const hasMemberSetting = member !== null
		&& typeof member === "object"
		&& Object.prototype.hasOwnProperty.call(member, "chatEnabled");

	return normalizeMemberChatEnabled(hasMemberSetting ? member.chatEnabled : fallback);
}
